<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-form v-if="loaded" v-model="formValid">
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 lg3>
                <v-select label="HC Organization" :items="authOrgs" item-text="name" item-value="id" autocomplete v-on:change="onChangeOrg"
                          v-model="params.hcorg" required :rules="rules.hcorganization" clearable />
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="Report Type" :items="reportType" v-model="params.reporttype" autocomplete />
              </v-flex>
               <v-flex xs12 lg3>
                <v-select label="Employees" :items="employees" item-text="value" item-value="empId" autocomplete  v-model="params.employee" clearable/>
                  <!-- <template slot="selection" slot-scope="data">
                    {{ data.item.name }} -  {{ data.item.nik }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }} -  {{ data.item.nik }}
                  </template>
                </v-select> -->
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="Division" :items="division" item-text="deptname" item-value="deptid" autocomplete v-model="params.divisi" clearable />
              </v-flex>
              <v-flex xs12 lg3 v-if="params.reporttype === 'Normal'">
                <v-select label="Outstanding State" :items="outstandingStates" v-model="params.outstate"
                          autocomplete />
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="Imposition Type" :items="impositionTypes" v-model="params.impotype" autocomplete
                          item-text="impositionType" item-value="impositionType" clearable />
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="Imposition" :items="impositions" v-model="params.impoid" autocomplete
                          item-text="impositionName" item-value="id" clearable />
              </v-flex>
             <v-flex xs12 lg3>
                <date-time-picker label="From Date" v-model="params.fdate" date-only :rules="rules.fromDate" clearable />
              </v-flex>
              <v-flex xs12 lg3>
                <date-time-picker label="To Date" v-model="params.tdate" date-only :rules="rules.toDate" clearable />
              </v-flex>
               <v-flex xs12 lg3>
                <v-select label="From City" :items="cities" item-text="value" item-value="value" autocomplete v-model="params.fcity" clearable />
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="To City" :items="cities" item-text="value" item-value="value" autocomplete v-model="params.tcity" clearable />
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="Group By" :items="sppdSumGroup" v-model="params.groupby" autocomplete />
              </v-flex>
              <v-flex xs12 lg3>
                <v-select label="Export Type" :items="exportTypes" v-model="params.type" autocomplete />
              </v-flex>
              <v-flex xs12>
                <v-btn color="primary" :disabled="!formValid" @click="cetak">
                  <v-icon>cloud_download</v-icon> Download</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DateTimePicker from '@/components/lookup/DateTimePicker'
import Vuex from 'vuex'
import _ from 'lodash'
import downloadFile from '@/helpers/download'
import moment from 'moment'

const organizationStore = Vuex.createNamespacedHelpers('Organization')
const impositionStore = Vuex.createNamespacedHelpers('BusinessTripImposition')
const genericStore = Vuex.createNamespacedHelpers('Generic')
const reportStore = Vuex.createNamespacedHelpers('Report')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

const defaultData = {
  hcorg: '',
  impotype: '',
  impoid: '',
  outstate: 'ALL',
  fdate: null,
  tdate: null,
  groupby: 'IMPOSITION',
  type: 'EXCEL',
  reporttype: 'Normal',
  fcity: '',
  tcity: '',
  employee: null,
  divisi: null
}

export default {
  name: 'BtSummary',
  components: {
    DateTimePicker
  },
  data () {
    return {
      title: 'Business Trip Summary',
      loaded: false,
      impositionLoaded: false,
      exportTypes: ['EXCEL', 'PDF'],
      reportType: ['Normal', 'Detail'],
      params: _.cloneDeep(defaultData),
      employees: [],
      division: [],
      formValid: false,
      rules: {
        hcorganization: [
          v => (typeof v !== 'undefined' && v !== '') || 'HC Organization required'
        ],
        fromDate: [
          v => v === null || this.params.tdate === null || this.params.fdate <= this.params.tdate || 'Invalid date'
        ],
        toDate: [
          v => v === null || this.params.fdate === null || this.params.fdate <= this.params.tdate || 'Invalid date'
        ]
      }
    }
  },
  computed: {
    ...organizationStore.mapState({
      authOrgs: 'authItems'
    }),
    ...impositionStore.mapState({
      impositionTypes: 'types',
      impositionActives: 'actives'
    }),
    ...genericStore.mapState({
      outstandingStates: 'outstandingStates',
      sppdSumGroup: 'sppdSumGroup',
      cities: 'cities'
    }),
    impositions () {
      return this.impositionLoaded ? this.impositionActives[this.params.impotype.toLowerCase()] : []
    }
  },
  watch: {
    'params.impotype' (newValue, oldValue) {
      if (typeof oldValue !== 'undefined') {
        const self = this
        self.params.impoid = ''
        self.impositionLoaded = false
        self.listActiveImposition({vueinstance: self, category: newValue})
          .then(res => {
            self.impositionLoaded = true
          }).catch(err => self.$error(err))
      }
    }
  },
  methods: {
    ...organizationStore.mapActions({
      listAuthorizedOrgs: 'listAuthorized'
    }),
    ...impositionStore.mapActions({
      listImpositionTypes: 'typeList',
      listActiveImposition: 'listActive'
    }),
    ...genericStore.mapActions({
      listOutstandingStates: 'listOutstandingStates',
      listSppdSumGroup: 'listSppdSumGroup',
      listCities: 'listCities'
    }),
    ...reportStore.mapActions({
      printSppdSummary: 'printSppdSummary'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    _setupToolbar () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', [])
    },
    loadResources () {
      const self = this
      self.loaded = false
      const promises = [
        self.listAuthorizedOrgs({vueinstance: self}),
        self.listImpositionTypes({vueinstance: self}),
        self.listOutstandingStates({vueinstance: self}),
        self.listSppdSumGroup({vueinstance: self}),
        self.listCities({vueinstance: self})
      ]
      Promise.all(promises)
        .then(res => {
          self.loaded = true
        }).catch(err => self.$error(err))
    },
    onChangeOrg (value) {
      this.$backend.generic.getEmployeesByOrgUsingGET({orgId: value})
        .then((res) => {
          this.employees = res.obj
        }).catch(err => self.$error(err))
      this.$backend.generic.getDepartmentsUsingGET({orgId: value})
        .then((res) => {
          this.division = res.obj
        }).catch(err => self.$error(err))
    },
    cetak () {
      const self = this
      this.$store.dispatch('Action/setLoading', true)
      self.printSppdSummary({vueinstance: self,
        params: {
          hcorg: self.params.hcorg,
          impotype: self.params.impotype,
          impoid: self.params.impoid,
          outstate: self.params.outstate,
          fromCity: self.params.fcity,
          toCity: self.params.tcity,
          fdate: self.params.fdate === null ? '' : moment(self.params.fdate).format('YYYYMMDD'),
          tdate: self.params.tdate === null ? '' : moment(self.params.tdate).format('YYYYMMDD'),
          groupby: self.params.groupby,
          type: self.params.type,
          reporttype: self.params.reporttype,
          empId: self.params.employee,
          divisionDeptId: self.params.divisi
        }
      }).then(res => {
        if (res.status === 200) {
          this.$store.dispatch('Action/setLoading', false)
          const type = res.data.type
          const ext = type.includes('excel') ? 'xls' : (type.includes('pdf') ? 'pdf' : '')
          downloadFile(res.data, 'sppd_summary.' + ext)
        } else {
          this.$store.dispatch('Action/setLoading', false)
          self.showConfirmation({
            message: '',
            title: 'No Data for selected parameter.',
            buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
          })
        }
      }).catch(err => self.$error(err))
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm._setupToolbar()
      vm.loadResources()
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bt-summary/BtSummary.vue